// TimelessXI: sticky add-to-cart for phones. See snippets/txi-sticky-atc.liquid.
if (!customElements.get('txi-sticky-atc')) {
  customElements.define(
    'txi-sticky-atc',
    class TxiStickyAtc extends HTMLElement {
      connectedCallback() {
        const id = this.dataset.section;
        this.mainButton = document.getElementById(`ProductSubmitButton-${id}`);
        this.priceEl = document.getElementById(`price-${id}`);
        this.variantEl = document.getElementById(`variant-selects-${id}`);
        if (!this.mainButton) return;

        this.button = this.querySelector('[data-txi-submit]');
        this.button.addEventListener('click', () => {
          if (this.mainButton.disabled) return;
          this.mainButton.click();
        });

        this.sync = this.sync.bind(this);
        this.sync();
        // Dawn re-renders the price and variant picker on variant change; watch for that.
        this.mutationObserver = new MutationObserver(this.sync);
        const watch = { subtree: true, childList: true, characterData: true, attributes: true };
        this.mutationObserver.observe(this.mainButton, watch);
        if (this.priceEl) this.mutationObserver.observe(this.priceEl, watch);
        if (this.variantEl) this.mutationObserver.observe(this.variantEl, watch);

        // Show the bar only while the main button is off screen.
        this.intersectionObserver = new IntersectionObserver((entries) => {
          const visible = entries[0].isIntersecting;
          this.hidden = visible;
          document.body.classList.toggle('txi-has-sticky-atc', !visible);
        });
        this.intersectionObserver.observe(this.mainButton);
      }

      disconnectedCallback() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        document.body.classList.remove('txi-has-sticky-atc');
      }

      sync() {
        // Re-query: Dawn replaces these nodes when the variant changes.
        const id = this.dataset.section;
        const main = document.getElementById(`ProductSubmitButton-${id}`) || this.mainButton;
        this.mainButton = main;
        const label = main.querySelector('span')?.textContent.trim();
        if (label) this.button.textContent = label;
        this.button.disabled = main.disabled;

        const price = document.getElementById(`price-${id}`);
        if (price) {
          const onSale = price.querySelector('.price--on-sale');
          const item = price.querySelector(onSale ? '.price__sale .price-item--last' : '.price__regular .price-item--regular');
          this.querySelector('[data-txi-price]').textContent = item ? item.textContent.trim() : '';
        }
        const selected = document.querySelector(`#variant-selects-${id} [data-selected-value]`);
        this.querySelector('[data-txi-variant]').textContent = selected ? selected.textContent.trim() : '';
      }
    }
  );
}
